var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ticketlist"},[_vm._m(0),(_vm.$store.state.ticketResources.length)?_c('state',{attrs:{"resourcesObj":_vm.resourcesObj}}):_vm._e(),_c('selector',{attrs:{"select":"selector-about"}}),_c('router-view')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"headerImage"},[_c('img',{attrs:{"src":require("@/assets/image/common/common_header.png"),"alt":""}})])
}]

export { render, staticRenderFns }